var flat = require('./flat.ejs');
var form = require('./form.ejs');
var html = require('./html.ejs');

export default { flat, form, html };
